import { Language } from 'i18n';

export enum LegalDocumentKind {
  TermsAndConditions = 'termsAndConditions',
  PrivacyPolicy = 'privacyPolicy',
  CookiePolicy = 'cookiePolicy',
  SizesChart = 'tableWithChartSizes'
}

interface ILegalDocument {
  url: string
  fileName: string
}

/** PDF served by the client bundle for the given document and language. */
export const getLegalDocument = (kind: LegalDocumentKind, language: string): ILegalDocument => {
  const isBg = language === Language.BG;

  switch (kind) {
    case LegalDocumentKind.TermsAndConditions:
      return isBg
        ? { url: require('assets/files/general-conditions/Общи условия 2_КИДДО.pdf'), fileName: 'Общи условия 2_КИДДО.pdf' }
        : { url: require('assets/files/general-conditions/General Conditions 2_KIDDO.pdf'), fileName: 'General Conditions 2_KIDDO.pdf' };
    case LegalDocumentKind.PrivacyPolicy:
      return isBg
        ? { url: require('assets/files/privacy-policy/ПОЛИТИКА_ЗА_ПОВЕРИТЕЛНОСТВЪВ_ВРЪЗКА_С_ОБРАБОТВАНЕТО_НА_ЛИЧНИ_ДАННИ.pdf'), fileName: 'ПОЛИТИКА_ЗА_ПОВЕРИТЕЛНОСТВЪВ_ВРЪЗКА_С_ОБРАБОТВАНЕТО_НА_ЛИЧНИ_ДАННИ.pdf' }
        : { url: require('assets/files/privacy-policy/Privacy_Policy_2KIDDO.pdf'), fileName: 'Privacy_Policy_2KIDDO.pdf' };
    case LegalDocumentKind.CookiePolicy:
      return isBg
        ? { url: require('assets/files/cookies-policy/ПОЛИТИКА_ЗА_ИЗПОЛЗВАНЕ_НА_БИСКВИТКИ.pdf'), fileName: 'ПОЛИТИКА_ЗА_ИЗПОЛЗВАНЕ_НА_БИСКВИТКИ.pdf' }
        : { url: require('assets/files/cookies-policy/Cookies_policy_2KIDDO.pdf'), fileName: 'Cookies_policy_2KIDDO.pdf' };
    case LegalDocumentKind.SizesChart:
      return isBg
        ? { url: require('assets/files/size-charts/2KIDDO_Size_Charts.pdf'), fileName: '2KIDDO_Size_Charts.pdf' }
        : { url: require('assets/files/size-charts/2KIDDO_Size_Charts_EN.pdf'), fileName: '2KIDDO_Size_Charts_EN.pdf' };
  }
};

export type LegalRun = string | { b?: string, i?: string };

export type LegalBlock =
  | { t: 'h', x: string, l: 2 | 3 }
  | { t: 'p', r: LegalRun[] }
  | { t: 'ul' | 'ml', items: LegalRun[][] };

export interface ILegalTable {
  caption: string
  head: string[]
  rows: string[][]
}

export interface ILegalContent {
  title: string | null
  blocks?: LegalBlock[]
  tables?: ILegalTable[]
}

/** The document text as structured data, converted from the PDF without changing the wording. */
export const getLegalContent = (kind: LegalDocumentKind, language: string): ILegalContent => {
  const isBg = language === Language.BG;

  switch (kind) {
    case LegalDocumentKind.TermsAndConditions:
      return isBg ? require('assets/legal/terms.bg.json') : require('assets/legal/terms.en.json');
    case LegalDocumentKind.PrivacyPolicy:
      return isBg ? require('assets/legal/privacy.bg.json') : require('assets/legal/privacy.en.json');
    case LegalDocumentKind.CookiePolicy:
      return isBg ? require('assets/legal/cookies.bg.json') : require('assets/legal/cookies.en.json');
    case LegalDocumentKind.SizesChart:
      return isBg ? require('assets/legal/sizes.bg.json') : require('assets/legal/sizes.en.json');
  }
};
